import {mustache} from "../handlebars_family.ts";
import * as i18n from "../i18n.ts";
import * as Html from "../util/Html.ts";
import * as blackveil from "../lib/blackveil2.ts";
import TPL from "../widget/action-menu.mustache";
import TPL_selected from "../widget/action-menu-selected.mustache";
import { TEMPLATE } from "../TEMPLATE.ts";
import Icons from "../svg/Icons.ts";
import { type ActionMenu, type ActionMenuButton, getData } from "./action-menu-registry.ts";

export function initDom(domObj: HTMLElement){
  var
    menu :HTMLElement,
    cancel :()=>void,
    displayNextToNode = domObj.getAttribute('data-position')==='parent'?domObj.parentElement:domObj,
    blackVeilObj = domObj.getAttribute('data-veil')==='body'?document.body.firstElementChild as HTMLElement:displayNextToNode;

  domObj.style.cursor = 'pointer';

  if(domObj.getAttribute('data-type')==='select'){
    var
      displayNodes :HTMLElement[],
      subInput = domObj.querySelector('input') as HTMLInputElement;
    async function majUI(){
      (await getData(domObj)).menu.forEach(function(option){
        if('html' in option) return;
        if(option.value===subInput.value){
          if(displayNodes){
            displayNodes = Html.replaceWithDom(displayNodes,TPL_selected,option)
          }else{
            displayNodes = Html.setHtmlAtStart(domObj,TPL_selected,option)
          }
        }
      })

    }
    subInput.addEventListener('change',majUI);
    majUI();
  }
  if(domObj.getAttribute('data-hasinit')==='true'){
    getData(domObj).then(menu=>{
      menu.init.apply(domObj)
    })
  }
  domObj.addEventListener('click',function(event){
    event.preventDefault();
    event.stopPropagation();
    if(menu!==undefined){
      cancel()
    }else{
      open(event);
    }
  })
  domObj.addEventListener('open',function(event){
    if(menu===undefined){
      open(event);
    }
  })

  async function refreshButtonFromData(index ?:number){
    var
      datas = await getData(domObj),
      buttons = datas.menu as ActionMenuButton[],
      selected = index===undefined?(buttons.filter(button=>button.selected)[0] || buttons[0]):buttons[index],
      html = (TEMPLATE`
${selected.svg?TEMPLATE`<icon class="${selected.iconclass}">${selected.svg}</icon>`:''}
${selected.emoji?TEMPLATE`<emoji class="${selected.iconclass}">${selected.emoji}</emoji>`:''}
<line class="flexauto">${selected.title}${i18n.get(selected.i18nkey)}</line>
<icon class="rotateable">${Icons.ic_chevron_down}</icon>`)

    domObj.innerHTML = html.toString();
  }

  //TODO merge this with data-type=select
  if(domObj.getAttribute('data-autofill')==='true'){
    refreshButtonFromData()
  }
  async function open(event,datas ?:ActionMenu){
    var
      datas = datas || await getData(domObj);

    if(datas.menu && datas.menu.length===1){
      var menu0 = datas.menu[0] as ActionMenuButton;
      if(menu0.submenu){
        datas = {menu:menu0.submenu}
      }
    }
    var
      objRect = displayNextToNode.getClientRects()[0],
      bodyRect = document.body.getClientRects()[0],
      openOnLeft = ( (objRect.left+objRect.right)/2<(bodyRect.left+bodyRect.right)/2 ),
      transformOrigin = []

    datas.css = datas.css||{}

    datas.css['min-width'] = Math.max(160,objRect.width)+'px'

    if(event.clientY===undefined || event.clientY<0.7*window.innerHeight){
      datas.css.top = (8+objRect.top+objRect.height)+"px";
      transformOrigin.push('top')
    }else{
      datas.css.bottom = (8+bodyRect.bottom-objRect.bottom+objRect.height)+"px";
      transformOrigin.push('bottom')
    }
    if(openOnLeft){
      datas.css.left = (objRect.left)+"px";
      transformOrigin.push('left')
    }else{
      datas.css.right = (bodyRect.right-objRect.right)+"px";
      transformOrigin.push('right')
    }
    datas.css['transform-origin'] = transformOrigin.join(' ');

    displayNextToNode.insertAdjacentHTML('afterend',mustache(TPL,datas));
    menu = displayNextToNode.nextSibling as HTMLElement;

    current = (()=>{
      objRect = displayNextToNode.getClientRects()[0];
      bodyRect = document.body.getClientRects()[0];
      if(transformOrigin.indexOf('top')!==-1){
        menu.style.top = (8+objRect.top+objRect.height)+"px";
      }else{
        menu.style.bottom = (8+bodyRect.bottom-objRect.bottom+objRect.height)+"px";
      }
      if(transformOrigin.indexOf('left')!==-1){
        menu.style.left = (objRect.left)+"px";
      }else{
        menu.style.right = (bodyRect.right-objRect.right)+"px";
      }

    });

    //dismissing without picking an entry, either through the veil or by clicking the opener again
    cancel = function(){
      if(datas.onCancel){
        datas.onCancel()
      }
      close()
    }
    blackveil.show(blackVeilObj).addEventListener('click',cancel);
    //a direct child is a menu entry and closes the menu, whatever its tag. Anything nested deeper
    //belongs to custom {html:...} content and drives its own lifecycle.
    menu.querySelectorAll(':scope>[data-fw-onclick]:not([data-fw-onclick="togglemenu"])').forEach(el => {
      el.addEventListener('click', close);
    });
    //FIXME make it work for submenu, whose data-menu-index is relative to the submenu
    menu.querySelectorAll('[data-menu-index]:not([data-fw-onclick])').forEach(el => {
      const index = Number(el.getAttribute('data-menu-index'));
      el.addEventListener('click', function(){
        const button = datas.menu[index] as ActionMenuButton;
        if(button.clickFunction) button.clickFunction()
        //TODO merge this with data-type=select
        if(el.classList.contains('fillMenu')) refreshButtonFromData(index)
        close()
      });
    });
    if(datas.content?.html){
      menu.innerHTML = datas.content?.html
    }
    datas.content?.init?.(menu,close);

    menu.style.display = 'block';
    menu.querySelectorAll<HTMLElement>('.selected').forEach(domNode=>{
      domNode.scrollIntoView({/* behavior: 'smooth',*/ block: 'nearest', inline: 'center' });
    });

    const rotateableIcon = domObj.querySelector('.rotateable') as HTMLElement;
    if(rotateableIcon) rotateableIcon.style.transform = 'rotateZ(180deg)';

  }
  function close(){
    domObj.style.zIndex = 'unset';
    blackveil.hide(blackVeilObj);
    menu.style.transform = 'scaleY(0)';
    const rotateableIcon = domObj.querySelector('.rotateable') as HTMLElement;
    if(rotateableIcon) rotateableIcon.style.transform = 'unset';
    current = undefined
    setTimeout(function(){
      //500ms later the menu might have been removed
      if(menu.parentNode){
        menu.parentNode.removeChild(menu);
      }
      menu = undefined;
    },500)
  }
  return {open,close}
}
export function destroyDom(o: HTMLElement){
  current = undefined
}
var current;
window.addEventListener('resize',()=>{
  if(current){
    current()
  }
})

Html.registerWidget("widget/action-menu",{initDom, destroyDom})